import { render, staticRenderFns } from "./MoleculeResourceCard.vue?vue&type=template&id=2710801a&scoped=true&"
import script from "./MoleculeResourceCard.vue?vue&type=script&lang=js&"
export * from "./MoleculeResourceCard.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeResourceCard.vue?vue&type=style&index=0&id=2710801a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710801a",
  null
  
)

export default component.exports